import { Currencies, Money } from 'ts-money';

/**
 *
 * @param {number} amount
 */
export const getMoneyObj = (amount) => {
  let moneyObj = new Money(Math.round(Number(amount) * 100), Currencies.USD, Math.ceil);
  moneyObj.__proto__.allocate = allocate;
  return moneyObj;
};

/**
 * Allocates fund bases on the ratios provided returning an array of objects as a product of the allocation.
 *
 * @param {number[]} ratios
 * @returns {Money[]}
 */
const allocate = function(ratios) {
  let self = this;
  let remainder = self.amount;
  let results = [];
  let total = 0;
  if (ratios.length === 0) {
    return results;
  }
  ratios.forEach((ratio) => {
    total += ratio;
  });
  ratios.forEach((ratio) => {
    let share = Math.floor(self.amount * ratio / total);
    results.push(new Money(share, self.currency));
    remainder -= share;
  });
  let i = 0;
  while (remainder > 0) {
    let norm_ind = i % results.length;
    if (ratios[norm_ind] > 0) {
      results[norm_ind] = new Money(results[norm_ind].amount + 1, results[norm_ind].currency);
      remainder--;
    }
    i += 1;
  }
  return results;
};
